export default {
  styleOverrides: {
    root: {
      border: '1px solid #C6CCDA',
      borderRadius: '10px'
    }
  }
};
